export const CHECKOUT_CLICK_TO_WIDGET_RENDER_METRIC_NAME = 'checkout.click_to_widget_render';

export interface CheckoutClickToWidgetRenderContext {
  durationMs: number;
  eventId?: string;
  stage?: string;
}

export const recordDatadogRumTiming = async (
  metricName: string,
  durationMs: number,
  actionContext?: Record<string, unknown>,
): Promise<void> => {
  try {
    if (typeof window === 'undefined') return;
    const rum = window.DD_RUM;
    if (!rum?.onReady || !rum.addAction) return;
    rum.onReady(() => {
      (rum as typeof rum & { addTiming?: (name: string, value?: number) => void }).addTiming?.(metricName, durationMs);
      rum.addAction?.(metricName, {
        ...(actionContext ?? {}),
        duration: durationMs,
        timestamp: Date.now(),
      });
    });
  } catch (error) {
    console.error('Error recording Datadog RUM timing:', error);
  }
};

export const recordComponentRenderTime = (componentName: string, startTime: number = 0): number => {
  const renderTime = performance.now();
  const timeElapsed = startTime > 0 ? renderTime - startTime : renderTime;
  const metricName = `component.render.${componentName}`;

  void recordDatadogRumTiming(metricName, timeElapsed);

  try {
    performance.mark(metricName);
    performance.measure(`${metricName}-measure`, undefined, metricName);
  } catch (error) {
    if (process.env.NODE_ENV !== 'production') {
      console.warn('User Timing API not available:', error);
    }
  }

  if (process.env.NODE_ENV !== 'production') {
    console.log(`[RUM Metric] ${metricName}: ${timeElapsed.toFixed(2)}ms`);
  }

  return timeElapsed;
};

export const recordCheckoutClickToWidgetRender = async (
  context: CheckoutClickToWidgetRenderContext,
): Promise<void> => {
  const { durationMs, eventId, stage } = context;
  const actionContext =
    eventId !== undefined || stage !== undefined
      ? {
          ...(eventId !== undefined ? { eventId } : {}),
          ...(stage !== undefined ? { stage } : {}),
        }
      : undefined;

  await recordDatadogRumTiming(CHECKOUT_CLICK_TO_WIDGET_RENDER_METRIC_NAME, durationMs, actionContext);
};
